"use client";
import { NotFoundState } from "@/components/not-found-state";

export default function NotFound() {
  return <NotFoundState />;
}
